import { render } from "./auth.vue?vue&type=template&id=8dbdc680&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=8dbdc680&scoped=true&lang=css"

import exportComponent from "C:\\active-project\\NeginPostClub\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbdc680"]])

export default __exports__